<app-top-navigation-bar></app-top-navigation-bar>
<!--<app-chat></app-chat>-->
<router-outlet></router-outlet>
<app-footer></app-footer>
